export default {
  "content": "<title>icons-200_slate-tt-48</title><path fill=\"none\" d=\"M0 0h48v48H0z\"/><path fill=\"#D7D8DE\" d=\"M7 15h11v6H7z\"/><path d=\"M47 8H29a6.185 6.185 0 00-5 2.018A6.185 6.185 0 0019 8H1a1 1 0 00-1 1v30a1 1 0 001 1h46a1 1 0 001-1V9a1 1 0 00-1-1zM2 10h17c1.2 0 4 .292 4 3v25H2zm44 28H25V13c0-2.708 2.8-3 4-3h17z\" fill=\"#3F4450\"/><path d=\"M18 14H7a1 1 0 00-1 1v6a1 1 0 001 1h11a1 1 0 001-1v-6a1 1 0 00-1-1zm-1 6H8v-4h9zM6 26h13v2H6zM6 32h13v2H6zM29 26h13v2H29zM29 32h13v2H29zM29 14h13v2H29zM29 20h13v2H29z\" fill=\"#3F4450\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48"
  }
};